import { useEffect, useState } from "react";
import Button from "../ui/Button";
import Container from "../ui/Container";
import NavLink from "./NavLink";

const navItems = [
  { label: "Products", href: "/products" },
  { label: "Blog", href: "#blog" },
  { label: "About", href: "#about" }
];

function Navbar({ currentPath, onNavigate }) {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 8);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
  }, [currentPath]);

  const handleNavigate = (href) => {
    onNavigate(href);
    setIsOpen(false);
  };

  return (
    <header
      className={`sticky top-0 z-50 border-b transition-all duration-200 ease-in-out ${
        scrolled
          ? "border-border/80 bg-background/82 backdrop-blur-xl"
          : "border-transparent bg-background/70 backdrop-blur-md"
      }`}
    >
      <Container>
        <nav className="flex h-16 items-center justify-between" aria-label="Main navigation">
          <a
            href="/"
            onClick={(event) => {
              event.preventDefault();
              handleNavigate("/");
            }}
            className="text-sm font-semibold tracking-[0.16em] text-primary transition-all duration-200 ease-in-out hover:text-accent focus-visible:shadow-focus-ring"
          >
            TECHNIE
          </a>

          <div className="hidden items-center gap-1 md:flex">
            {navItems.map((item) => (
              <NavLink
                key={item.label}
                href={item.href}
                active={currentPath === item.href}
                onNavigate={handleNavigate}
              >
                {item.label}
              </NavLink>
            ))}
          </div>

          <div className="hidden md:block">
            <Button onClick={() => handleNavigate("/products")}>View Products</Button>
          </div>

          <button
            type="button"
            aria-label="Toggle navigation menu"
            aria-expanded={isOpen}
            onClick={() => setIsOpen((value) => !value)}
            className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-border/80 text-primary transition-all duration-200 ease-in-out hover:border-accent/45 hover:bg-surface/35 hover:text-accent active:translate-y-px focus-visible:shadow-focus-ring md:hidden"
          >
            <span className="relative h-4 w-5">
              <span
                className={`absolute left-0 top-0 h-px w-5 bg-current transition-all duration-200 ease-in-out ${
                  isOpen ? "translate-y-2 rotate-45" : ""
                }`}
              />
              <span
                className={`absolute left-0 top-2 h-px w-5 bg-current transition-all duration-200 ease-in-out ${
                  isOpen ? "opacity-0" : "opacity-100"
                }`}
              />
              <span
                className={`absolute left-0 top-4 h-px w-5 bg-current transition-all duration-200 ease-in-out ${
                  isOpen ? "-translate-y-2 -rotate-45" : ""
                }`}
              />
            </span>
          </button>
        </nav>

        <div
          className={`grid overflow-hidden transition-all duration-200 ease-in-out md:hidden ${
            isOpen ? "grid-rows-[1fr] pb-4 opacity-100" : "grid-rows-[0fr] opacity-0"
          }`}
        >
          <div className="min-h-0">
            <div className="flex flex-col gap-1 border-t border-border/70 pt-3">
              {navItems.map((item) => (
                <NavLink
                  key={item.label}
                  href={item.href}
                  active={currentPath === item.href}
                  onNavigate={handleNavigate}
                >
                  {item.label}
                </NavLink>
              ))}
              <Button className="mt-2 w-full" onClick={() => handleNavigate("/products")}>
                View Products
              </Button>
            </div>
          </div>
        </div>
      </Container>
    </header>
  );
}

export default Navbar;
